import { defineRouting } from 'next-intl/routing'

export const locales = ['en', 'fr'] as const

export const routing = defineRouting({
    locales: locales,
    defaultLocale: 'en'
})
